import HelpDeskHeader from './Header/HelpDeskHeader';
import HelpDeskHome from './Home/HelpDeskHome';
import HelpDeskCategory from './Categories/HelpDeskCategory';
import HelpDeskQuestion from './Questions/HelpDeskQuestion';
import HelpDeskContact from './Contact/HelpDeskContact';
import HelpDeskSearch from './Search/HelpDeskSearch';

export {
  HelpDeskHeader,
  HelpDeskHome,
  HelpDeskCategory,
  HelpDeskQuestion,
  HelpDeskContact,
  HelpDeskSearch,
};
